import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {LoginInterface, ResendOTPRequest, User, VerifyOTPRequest} from '../../../interfaces/loginInterface';
import {COMMON_CONSTANT} from '../../config/constants/common-keys.constants';

@Injectable({
  providedIn: 'root',
})
export class LoginService {

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  }

  constructor(private _http: HttpClient) {
  }

  login(payload: LoginInterface): Observable<any> {
    return this._http.post(`${COMMON_CONSTANT.API_BASE_URL}/auth/customer/login`, payload, this.httpOptions);
  }

  sendResetMail(username: string): Observable<any> {
    return this._http.post(`${COMMON_CONSTANT.API_BASE_URL}/auth/reset-password-token`, {username});
  }

  checkResetPasswordToken(token: string): Observable<any> {
    const params = new HttpParams().set('token', token)
    return this._http.get(`${COMMON_CONSTANT.API_BASE_URL}/auth/reset-password`, {params})
  }

  resetPassword(token: string, password: string, username: string, userRole: 'ADMIN' | 'CLIENT'): Observable<any> {
    const params = new HttpParams().set('userRole', userRole)
    return this._http.put<any>(`${COMMON_CONSTANT.API_BASE_URL}/auth/reset-password`, {
        username,
        password,
        token
      }, {params}
    );
  }

  resendOTP(userPayload: ResendOTPRequest): Observable<any> {
    return this._http.post<any>(`${COMMON_CONSTANT.API_BASE_URL}/auth/resend-otp`, userPayload, this.httpOptions);
  }

  verifyOTP(userPayload: VerifyOTPRequest): Observable<any> {
    return this._http.post(`${COMMON_CONSTANT.API_BASE_URL}/auth/verify-otp`, userPayload, this.httpOptions);
  }

  getCustomerLoginUser() {
    return this._http.get<User>(`${COMMON_CONSTANT.API_BASE_URL}/customers/contact/me`,this.httpOptions)
  }

  getWebSiteLogo() {
    return this._http.get<any>(`${COMMON_CONSTANT.API_BASE_URL}/website`,this.httpOptions);
  }
}
